export const LS_KEY_CONNECTED_CONNECTOR = "connected-connector";
